<template>
  <UiSectionWrapper
    title="Bisnis Jalan Tanpa Hambatan Pembayaran"
    sub-title="KiriminAja Kredit"
    description="Aktifkan KA Kredit sekarang untuk efisiensi, kecepatan, dan kontrol keuangan yang lebih solid."
    hero-image="/images/ka-kredit-banner-5.webp"
    class="bg-primary-container dark:bg-surface-container-high py-10 lg:py-0"
    image-class="hidden lg:block"
    button-label="Aktifkan KA Kredit"
    :button-link="
      $utm.utmUrl('/login', {
        redirectTo: '/credit'
      })
    "
  />
</template>
